import {authHeader, handleHttpResponse, objectToQueryString} from '_helpers';
import {SERVER_URL} from 'config';

export const billingService = {
    getBillingSettingsLink,
    getBillingsSummary,
    getOrganizationBillingBreakdown
};

function getBillingSettingsLink() {
    return fetch(`${SERVER_URL}/api/billing/settings`,
        {
            method: 'GET',
            headers: authHeader(),
        })
        .then(handleHttpResponse);
}

function getBillingsSummary(params) {
    return fetch(`${SERVER_URL}/api/v1/billing/summary?${objectToQueryString((params))}`,
        {
            method: 'GET',
            headers: authHeader(),
        })
        .then(handleHttpResponse);
}

function getOrganizationBillingBreakdown(params) {
    return fetch(`${SERVER_URL}/api/v1/billing/organization/breakdown?${objectToQueryString((params))}`,
        {
            method: 'GET',
            headers: authHeader(),
        })
        .then(handleHttpResponse);
}